import { jsxs, jsx } from 'react/jsx-runtime';
import React__default, { useState, useCallback, useEffect, useMemo, Fragment } from 'react';
import { useEditorState } from '@tiptap/react';
import { createGlobalStyle } from 'styled-components';
import { mediaMobile } from '@fabric-app/ui/constants/styled-utils';
import { Toolbar } from '../../../toolbar/components/Toolbar.js';

const ToolbarGlobalStyles = createGlobalStyle([
  ``,
  `{:root{--toolbar-height:`,
  `px;}}`
], mediaMobile, (p) => p.toolbarHeight || 0);
const preventEditorLoseFocus = (editor) => (e) => {
  if (editor.isFocused) {
    e.preventDefault();
  } else {
    editor.chain().focus();
  }
};
const TiptapToolbar = ({ editor, groups: groupsProp, floating, onToolbarHeightChange: onToolbarHeightChangeProp, noSeperator = false, mobileTarget, suffix }) => {
  const toolbarRef = React__default.useRef(null);
  const [toolbarHeight, setToolbarHeight] = useState(0);
  const onToolbarHeightChange = useCallback((height) => {
    setToolbarHeight(height);
    onToolbarHeightChangeProp?.(height);
  }, [
    onToolbarHeightChangeProp
  ]);
  useEffect(() => {
    if (!toolbarRef.current) {
      return;
    }
    const handleTouchMove = (e) => {
      if (e.target instanceof HTMLElement && e.target.closest("[data-prevent-touch-move]")) {
        e.preventDefault();
      }
    };
    toolbarRef.current.addEventListener("touchmove", handleTouchMove, {
      passive: false
    });
    return () => {
      toolbarRef.current?.removeEventListener("touchmove", handleTouchMove);
    };
  }, [
    editor
  ]);
  const [rerender, setRerender] = useState(0);
  const { selection } = useEditorState({
    editor,
    selector: (snapshot) => ({
      selection: snapshot.editor.state.selection
    })
  });
  useEffect(() => {
    const onTransaction = ({ transaction }) => {
      if (transaction.selectionSet || transaction.docChanged) setRerender((prev) => prev + 1);
    };
    editor.on("transaction", onTransaction);
    return () => {
      editor.off("transaction", onTransaction);
    };
  }, [
    editor
  ]);
  const groups = useMemo(() => {
    return groupsProp.map((group) => group(editor, selection));
  }, [
    groupsProp,
    editor,
    selection,
    rerender
  ]);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx(Toolbar.Base, {
        onClick: preventEditorLoseFocus(editor),
        onMouseDown: preventEditorLoseFocus(editor),
        "data-tiptap-toolbar": true,
        "data-tiptap-fixed-toolbar": true,
        suffix,
        groups,
        floating,
        onToolbarHeightChange,
        noSeparator: noSeperator,
        mobileTarget,
        ref: toolbarRef
      }),
      /* @__PURE__ */ jsx(ToolbarGlobalStyles, {
        toolbarHeight
      })
    ]
  });
};

export { TiptapToolbar as default };
//# sourceMappingURL=Toolbar.js.map
